export default __webpack_public_path__ + "static/media/app-icon.0733b9c3.png";